import {
  Row,
  Col,
  Tabs,
  Pagination,
  Menu,
  Button,
  Dropdown,
  Icon,
  Form,
  message,
  Spin
} from "antd";
import isEqual from "lodash/isEqual";
import WeaFormItem from "../../wea-form-item";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";

import WeaInputSearch from "../../wea-input-search";
import WeaSearchBrowserBox from "../wea-search-browser-box";
import WeaAssociativeSearchMult from "../wea-associative-search-mult";
import WeaNewScroll from "../../wea-new-scroll";
import WeaDialog from "../../wea-dialog";
import Operation from "./operation";
import WeaTransferRight from "../wea-transfer-right";
import WeaTreeHrMult from "../wea-tree-hr-mult";
import WeaTools from "../../wea-tools";
import WeaHrmList from "../wea-hrm-list";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import debounce from "lodash/debounce";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;
const TabPane = Tabs.TabPane;

const initialState = {
  searched: false,
  showSearchAd: false,
  hasPagination: true,
  count: 0,
  visible: false,
  currentPage: 1,
  inputValue: "",
  searchPara: {},
  browserConditions: [],
  isAccount: false,
  checkStrictly: false,
  leftListSelectedKeys: [],
  leftListSelectedData: [],
  showAllbranch: false,
  showList: true,
  listDatas: [],
  loading: true,
  inputTop: null,
  inputBottom: null
};

class main extends React.PureComponent {
  static Operation = Operation;
  static defaultProps = {
    mult: true,
    topPrefix: "wea",
    isShowGroup: false,
    defualtTabs: [],
    extendTabs: []
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: null,
      showDrop: false,
      virtualDatas: [],
      companysDefault: "",
      companyId: null,
      initialShowSearchAd: false,
      showSearchAd: false,
      grouptreeData: null,
      rsctreeData: null,
      searched: false, // 高级搜索的状态
      rightCheckedKeys: [], //右侧选择的keys
      rightDatas: [], // 右侧展示的数据
      leftListSelectedKeys: [], // 左侧table选择的keys
      leftListSelectedData: [], // 左侧table选择的数据
      leftTreeCheckedKeys: [], // 左侧tree选择的keys
      leftTreeCheckedData: [], // 左侧tree选择的数据
      selectedData: {}, // 搜索按钮选中的数据
      searchKeys: [], // 搜索按钮选择的keys
      leftGroupCheckedKeys: [], //左侧group 选择的keys
      leftGroupCheckedData: [],
      listDatas: [],
      currentPage: 1,
      pageSize: props.pageSize || 20,
      hasPagination: true,
      count: 0,
      inputValue: "",
      searchPara: {},
      hiddenIds: "",
      browserConditions: [],
      quickSearch: "",
      checkStrictly: false, // 是否联动子节点
      isAccount: false, // 有无账号
      showAllbranch: false,
      loading: true,
      activeKey: "1",
      listApiOrder: 1,
      tabsFromApi: null
    };
  }
  componentDidMount() {
    // 默认显示数据
    if (!isEmpty(this.props.appendDatas)) {
      this.appendSearchValues(this.props.appendDatas, true);
    }
    if (!isEmpty(this.props.replaceDatas)) {
      this.replaceSearchValues(this.props.replaceDatas);
    }
    if (!isEmpty(this.props.valueObj)) {
      this.replaceSearchValues(this.props.valueObj);
    }
    this.props.initFunc && this.props.initFunc(this);
    this.debounced = debounce(this.onSearchChange, 500).bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && isEmpty(nextProps.value)) {
      this.setState({ searchKeys: [], selectedData: {} });
      this.refs.associativeSearch && this.refs.associativeSearch.clear();
    }
    if (
      "appendDatas" in nextProps &&
      !isEqual(this.props.appendDatas, nextProps.appendDatas) &&
      nextProps.appendDatas.length > 0
    ) {
      this.appendSearchValues(nextProps.appendDatas, true);
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      this.replaceSearchValues(nextProps.replaceDatas || []);
      if (isEmpty(nextProps.replaceDatas)) {
        this.refs.associativeSearch && this.refs.associativeSearch.clear();
      }
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.value !== nextProps.value ||
      this.props.appendDatas !== nextProps.appendDatas ||
      this.props.replaceDatas !== nextProps.replaceDatas ||
      this.props.form !== nextProps.form ||
      this.state.visible !== nextState.visible ||
      this.state.activeKey !== nextState.activeKey ||
      this.state.virtualDatas !== nextState.virtualDatas ||
      this.state.companysDefault !== nextState.companysDefault ||
      this.state.companyId !== nextState.companyId ||
      this.state.initialShowSearchAd !== nextState.initialShowSearchAd ||
      this.state.showSearchAd !== nextState.showSearchAd ||
      this.state.grouptreeData !== nextState.grouptreeData ||
      this.state.rsctreeData !== nextState.rsctreeData ||
      this.state.searched !== nextState.searched ||
      this.state.rightCheckedKeys !== nextState.rightCheckedKeys ||
      this.state.rightDatas !== nextState.rightDatas ||
      this.state.leftListSelectedKeys !== nextState.leftListSelectedKeys ||
      this.state.leftListSelectedData !== nextState.leftListSelectedData ||
      this.state.leftTreeCheckedKeys !== nextState.leftTreeCheckedKeys ||
      this.state.leftTreeCheckedData !== nextState.leftTreeCheckedData ||
      this.state.selectedData !== nextState.selectedData ||
      this.state.searchKeys !== nextState.searchKeys ||
      this.state.leftGroupCheckedKeys !== nextState.leftGroupCheckedKeys ||
      this.state.leftGroupCheckedData !== nextState.leftGroupCheckedData ||
      this.state.showDrop !== nextState.showDrop ||
      this.state.listDatas !== nextState.listDatas ||
      this.state.loading !== nextState.loading ||
      this.state.currentPage !== nextState.currentPage ||
      this.state.hasPagination !== nextState.hasPagination ||
      this.state.inputValue !== nextState.inputValue ||
      this.state.browserConditions !== nextState.browserConditions ||
      this.state.isAccount !== nextState.isAccount ||
      this.state.checkStrictly !== nextState.checkStrictly ||
      this.state.showAllbranch !== nextState.showAllbranch ||
      this.state.count !== nextState.count
    );
  }
  callApi() {
    const { virtualUrl } = this.props;
    WeaTools.callApi(virtualUrl, "GET").then(data => {
      //,{isaccount:isaccount,min:min,max:max}
      let companysDefault = data.datas.map(item => {
        if (item.id == 0) return item.virtualtype;
      });
      this.setState({
        companysDefault: companysDefault, //获取行政组织
        virtualDatas: data.datas
      });
      this.companysDefault = companysDefault;
      this.companysDefaultId = 0;
    });
    this.getResourceTree();
    this.getGrouptree();
  }
  openModal() {
    this.onCustomClick();
  }
  closeModal() {
    this.setState({ visible: false });
  }
  setLoading(bool) {
    this.setState({ loading: bool });
  }
  getResourceTree(companyId = 0, isAccount = true) {
    const { resourcetree } = this.props;
    let params = {};
    if (companyId < 0) params.virtualtype = companyId;
    if (isAccount) params["isNoAccount"] = 1;
    this.setLoading(true);
    WeaTools.callApi(resourcetree, "GET", {
      ...this.defaultConditionParams,
      ...params
    }).then(datas => {
      //按照组织结构
      this.setState({ rsctreeData: datas, loading: false });
    });
  }
  getGrouptree = (isAccount = true) => {
    const { grouptree } = this.props;
    let params = {};
    if (isAccount) params["isNoAccount"] = 1;
    this.setLoading(true);
    WeaTools.callApi(grouptree, "GET", {
      ...this.defaultConditionParams,
      ...params
    }).then(datas => {
      //常用组
      this.setState({ grouptreeData: datas, loading: false });
    });
  };
  onBranchBtnClick() {
    const { showAllbranch, isAccount } = this.state;
    let url = "/api/public/browser/data/1?cmd=branch";
    this.getLists(
      url,
      1,
      true,
      this.defaultConditionParams,
      null,
      isAccount,
      !showAllbranch
    );
    this.setState({ showAllbranch: !showAllbranch });
  }
  onAccountBtnClick() {
    const { searched, isAccount, activeKey, showAllbranch } = this.state;
    let url;
    let params = this.defaultConditionParams;
    if (searched) {
      (url = "/api/public/browser/data/1?cmd=search"),
        (params = this.state.searchPara);
    } else if (activeKey === "1") {
    } else if (activeKey === "2") {
      url = "/api/public/browser/data/1?cmd=underling"; //同部门
    } else if (activeKey === "3") {
      url = "/api/public/browser/data/1?cmd=branch"; //我的下属
    } else if (activeKey === "4") {
      // 组织结构
      const { companyId } = this.state;
      this.getResourceTree(companyId, !isAccount);
    } else if (activeKey === "5") {
      this.getGrouptree(!isAccount);
    }
    if (searched || activeKey === "2" || activeKey === "3") {
      this.getLists(url, 1, true, params, null, !isAccount, showAllbranch);
    }
    this.setState({ isAccount: !isAccount, currentPage: 1 });
  }
  getLists(
    url,
    currentPage,
    hasPagination,
    searchPara = {},
    companyId,
    isAccount = true,
    showAllbranch = false,
    activeKey,
    cb
  ) {
    const { dataParams = {} } = this.props;
    this.setLoading(true);
    let params = { ...searchPara };
    const { pageSize } = this.state;
    url = url || this.state.url;
    currentPage = currentPage || this.state.currentPage;
    hasPagination = hasPagination || this.state.hasPagination;
    if (companyId === undefined || companyId === null) {
      companyId = this.state.companyId;
    }
    if (hasPagination) {
      params["min"] = (currentPage - 1) * pageSize + 1;
      params["max"] = currentPage * pageSize;
    }
    if (companyId) params["virtualtype"] = companyId;
    if (isAccount) params["isNoAccount"] = 1;
    activeKey = activeKey || this.state.activeKey;
    if (showAllbranch && activeKey === "3") params["alllevel"] = 1;

    let { listApiOrder } = this.state;
    let currentOrder = listApiOrder + 1;
    this.setState({ listApiOrder: currentOrder });

    WeaTools.callApi(url, "GET", { ...params, ...dataParams })
      .then(data => {
        if (currentOrder < this.state.listApiOrder) {
          return;
        }
        if (cb) cb(data, { ...params, ...dataParams }, url);
        if (data && data.columns) this.formatInput(data.columns);
        data.datas.forEach(item => {
          item.icon = item.messagerurl;
          item.nodeid = `resource_${item.id}x`;
          item.type = "resource";
        });
        this.setState({
          listDatas: data.datas,
          count: data.count,
          loading: false
        });
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }
  onTabsChange(activeKey) {
    let url,
      companyId,
      hasPagination = true,
      hasCustomedTabUrl = false; // 是否有模块自定义的浏览按钮url
    const { resetFields, setFieldsValue } = this.props.form;
    const { isAccount, showAllbranch } = this.state;
    setFieldsValue(this.defaultConditionParams);
    resetFields();
    this.setState({ browserConditions: [] }, () => {
      if (activeKey === "1") {
        url = "/api/public/browser/data/1?cmd=newly"; // 最近
        companyId = null;
      } else if (activeKey === "2") {
        url = "/api/public/browser/data/1?cmd=underling"; //同部门
        companyId = this.companysDefaultId;
      } else if (activeKey === "3") {
        url = "/api/public/browser/data/1?cmd=branch"; //我的下属
        companyId = this.companysDefaultId;
      } else if (activeKey === "4") {
        // 组织结构
        companyId = this.companysDefaultId;
        this.getResourceTree(companyId, isAccount);
        hasPagination = false;
      } else {
        const tabs = this.getTabs();
        const currentTab = tabs.filter(tab => tab.key === activeKey)[0] || {};
        if (currentTab.url) {
          // 自定义tab 自定义url处理
          hasCustomedTabUrl = true;
          url = currentTab.url;
          companyId = null;
          hasPagination = currentTab.hasPagination || true;
        } else {
          companyId = null;
          hasPagination = false;
        }
      }
      const quickSearch = this.state.quickSearch || "name";
      this.setState({
        hasPagination,
        url,
        activeKey,
        companyId,
        count: 0,
        currentPage: 1,
        inputValue: this.defaultConditionParams[quickSearch] || "",
        showSearchAd: false,
        searched: false,
        companysDefault: this.companysDefault,
        browserConditions: this.browserConditionsBk,
        searchPara: { ...this.defaultConditionParams }
      });
      if (
        activeKey === "1" ||
        activeKey === "2" ||
        activeKey === "3" ||
        hasCustomedTabUrl
      ) {
        this.getLists(
          url,
          1,
          true,
          this.defaultConditionParams,
          0,
          isAccount,
          showAllbranch,
          activeKey
        );
      }
      this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
    });
  }
  onPageChange(page) {
    this.getLists(
      "",
      page,
      true,
      this.state.searchPara,
      "",
      this.state.isAccount,
      this.state.showAllbranch
    );
    this.setState({ currentPage: page });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  onSearchChange(v) {
    //按照人员姓名搜索
    const quickSearch = this.state.quickSearch || "name";
    const { form } = this.props;
    const { setFieldsValue, validateFields } = form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    // validateFields((errors, object) => {
    //   if (!!errors) {
    //     message.error("Errors in form!!!");
    //     return;
    //   }
    //   forEach(object, (value, key) => {
    //     if (value !== undefined) params[key] = value;
    //   });
    // });
    params[quickSearch] = v;
    const url = "/api/public/browser/data/1?cmd=search";
    this.getLists(url, 1, true, params, 0, this.state.isAccount); // 搜索获取数据
    setFieldsValue(params); // 高级搜索数据联动
    this.setState({
      searched: true,
      hasPagination: true,
      // inputValue: v,
      url,
      showSearchAd: false,
      activeKey: "",
      searchPara: params
    });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  goSearch = e => {
    e.preventDefault();
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
    const quickSearch = this.state.quickSearch || "name";
    const { form } = this.props;
    // const { validateFields } = this.props.form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    // validateFields((errors, object) => {
    //   if (!!errors) {
    //     message.error("Errors in form!!!");
    //     return;
    //   }
    //   forEach(object, (value, key) => {
    //     if (value !== undefined) params[key] = value;
    //   });
    // });
    const url = "/api/public/browser/data/1?cmd=search";
    this.getLists(
      url,
      1,
      true,
      params,
      0,
      true,
      false,
      0,
      (data, param, _url) => {
        if (
          window.browserSearchHandler &&
          typeof window.browserSearchHandler === "function"
        ) {
          window.browserSearchHandler(data, param, _url);
        }
      }
    ); // 搜索获取数据
    this.setState({
      isAccount: true,
      hasPagination: true,
      searchPara: params,
      showSearchAd: false,
      searched: true,
      inputValue: params[quickSearch] || "",
      activeKey: "",
      url
    });
  };
  showModal() {
    this.setState({ visible: true });
    this.props.onOpen && this.props.onOpen();
  }
  onSelect(e) {
    const { activeKey, virtualDatas } = this.state;
    let _this = this;
    virtualDatas.forEach(item => {
      if (e.key == item.id) {
        _this.setState({
          companysDefault: item.virtualtype,
          companyId: e.key
        });
        if (activeKey === "4") {
          this.getResourceTree(e.key);
        } else {
          this.getLists(null, 1, true, {}, e.key);
        }
      }
    });
  }

  setShowSearchAd(bool) {
    this.setState({ showSearchAd: bool, initialShowSearchAd: true });
  }
  getDefaultActiveKey() {
    let activeKey = "1";
    const tabs = this.getTabs();
    if (Array.isArray(tabs) && !isEmpty(tabs)) {
      let t = tabs[0];
      tabs.forEach(tab => {
        if (tab.selected) {
          t = tab;
        }
      });
      return t.key;
    }
    return activeKey;
  }
  onBrowerClick = (keys, selectedObj) => {
    const { resetFields } = this.props.form;
    resetFields(); // 重置高级搜索
    const { conditionURL } = this.props;
    WeaTools.callApi(conditionURL, "GET").then(data => {
      let quickSearch;
      if (!isEmpty(data.conditions)) {
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
          }
        });
      }
      const params = WeaTools.getParamsByConditions(data.conditions);
      let activeKey = this.getDefaultActiveKey(),
        searched = false;
      if (!isEmpty(params)) {
        // 初始条件更新在form中
        const { setFieldsValue } = this.props.form;
        setFieldsValue(params);
      }
      this.browserConditionsBk = data.conditions;
      this.defaultConditionParams = { ...params }; // 请求接口的默认条件
      this.setState(
        {
          browserConditions: data.conditions,
          quickSearch,
          inputValue: params[quickSearch] || "",
          searchPara: params,
          searched,
          tabsFromApi: data.tabs
        },
        () => {
          this.onTabsChange(activeKey);
        }
      );
      this.callApi();
    });
    this.showModal();

    // reset selected data
    if (!isEmpty(keys)) {
      this.onBrowerChange(keys, selectedObj, true, false);
    } else {
      this.setState({ rightDatas: [] });
    }
  };
  handleOk() {
    const { rightDatas } = this.state;
    const { maxLength } = this.props;
    let values = [];
    let selectedData = {};
    if (!isEmpty(rightDatas)) {
      if (maxLength && maxLength < this.countCrm(rightDatas, true)) {
        window.alert(
          getLabel(385619, "所选人数不能超出$s人!").replace(/\$s/, maxLength)
        );
        return;
      }
      rightDatas.forEach(item => {
        let id;
        if (item.type === "resource") {
          id = item.id;
        } else {
          if (!isEmpty(item.users)) {
            id = [];
            item.users.forEach(u => {
              id.push(u.id);
            });
            id = id.join(",");
          }
        }
        if (id && values.indexOf(id) < 0) {
          selectedData[id] = item;
          values.push(id);
        }
      });
    }
    values = uniq(values);
    const formatdKeys = this.formatKeys(values, selectedData);
    const formaredDatas = this.formatDatas(rightDatas);
    this.setState(
      {
        visible: false,
        searchKeys: formatdKeys,
        selectedData: selectedData
      },
      () => {
        this.throwCurrentState(formatdKeys.join(","), formaredDatas);
      }
    );
    this.props.onClose && this.props.onClose();
    if (values.length > 0)
      WeaTools.callApi("/api/public/browser/data/1", "post", {
        cmd: "addList",
        ids: values.join(",")
      });
    this.setState(initialState); //初始化浏览框
    this.refs.browserRight && this.refs.browserRight.reset();
  }

  handleCancel() {
    this.setState(initialState); //初始化浏览框
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onClose && this.props.onClose();
  }
  handleClear() {
    this.setState({
      visible: false,
      rightDatas: [],
      rightCheckedKeys: [],
      leftTreeCheckedKeys: [],
      leftListSelectedKeys: [],
      leftListSelectedData: [],
      leftTreeCheckedData: [],
      leftGroupCheckedData: [],
      selectedData: {},
      searchKeys: [],
      leftGroupCheckedKeys: []
    });
    this.setState(initialState); //初始化浏览框
    this.throwCurrentState("", []);
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onClose && this.props.onClose();
  }
  onBrowerChange(values, datas, needFormat = false, needOnchange = true) {
    let rDatas = [];
    values.forEach(v => {
      rDatas.push(datas[v]);
    });

    const formatdKeys = this.formatKeys(values, datas);
    if (needFormat) {
      this.formatCheckedData(rDatas, true).then(result => {
        const formatedDatas = this.formatDatas(result);
        this.setState({
          searchKeys: formatdKeys,
          selectedData: datas,
          rightDatas: formatedDatas
        });
        if (needOnchange)
          this.throwCurrentState(formatdKeys.join(","), formatedDatas);
      });
    } else {
      const formatedDatas = this.formatDatas(rDatas);
      this.setState({
        searchKeys: formatdKeys,
        selectedData: datas,
        rightDatas: formatedDatas
      });
      if (needOnchange)
        this.throwCurrentState(formatdKeys.join(","), formatedDatas);
    }
  }
  appendSearchValues(datas, needFilter = false) {
    const { searchKeys, selectedData, rightDatas } = this.state;
    let searchKeysB = cloneDeep(searchKeys);
    let selectedDataB = cloneDeep(selectedData);
    let rightDatasB = cloneDeep(rightDatas);
    if (needFilter) datas = this.filterDatas(datas);
    this.setSearchValues(datas, searchKeysB, selectedDataB, rightDatasB, true);
  }
  set(datas) {
    this.replaceSearchValues(datas);
  }
  get() {
    const { rightDatas } = this.state;
    let values = [];
    !isEmpty(rightDatas) &&
      rightDatas.forEach(d => {
        values.push(d.id);
      });
    return {
      ids: values,
      datas: rightDatas
    };
  }
  reload() {
    this.onBrowerClick();
  }
  replaceSearchValues(datas) {
    let searchKeysB = [];
    let selectedDataB = {};
    let rightDatasB = [];
    this.setSearchValues(datas, searchKeysB, selectedDataB, rightDatasB);
  }
  getTabs() {
    const { tabsFromApi } = this.state;
    const { tabs, extendTabs } = this.props;
    let defualtTabs = [
      {
        name: getLabel(24515, "最近"),
        key: "1"
      },
      {
        name: getLabel(18511, "同部门"),
        key: "2"
      },
      {
        name: getLabel(15089, "我的下属"),
        key: "3"
      },
      {
        name: getLabel(18770, "按组织结构"),
        key: "4"
      },
      {
        name: getLabel(81554, "常用组"),
        key: "5"
      }
    ];
    defualtTabs =
      this.props.defualtTabs.length == 0 ? defualtTabs : this.props.defualtTabs;
    const resTabs = tabs || tabsFromApi || [...defualtTabs, ...extendTabs];
    return resTabs;
  }
  renderTab() {
    const { activeKey } = this.state;
    const tabs = this.getTabs();
    return (
      <div className="wea-tab">
        <Tabs onChange={this.onTabsChange.bind(this)} activeKey={activeKey}>
          {tabs &&
            tabs.map(
              tab => tab.key != "6" && <TabPane tab={tab.name} key={tab.key} />
            )}
        </Tabs>
      </div>
    );
  }
  setSearchValues(
    datas,
    searchKeysB,
    selectedDataB,
    rightDatasB,
    doChange = false
  ) {
    const { maxLength } = this.props;
    if (datas && datas.length > 0) {
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i];
        if (data) {
          let id;
          data.type = data.type || "resource";
          data.lastname = data.lastname || data.name || "";

          if (data.type === "all") {
            // 所有人
            data.nodeid = "all_x";
            id = data.ids;
            searchKeysB = [id];
            rightDatasB = [data];
            selectedDataB = {};
            selectedDataB[id] = data;
            break;
          } else if (data.type === "resource") {
            data.nodeid = `resource_${data.id}x`;
            id = data.id;
            // // 去重
            // const groups = datas.filter(d => d.type != 'resource');
            // if (!isEmpty(groups)) {
            //     groups.forEach((g) => {
            //         if (g.users && g.users.filter((u) => u.id === data.id).length > 0) {
            //             id = undefined;
            //         }
            //     })
            // }
          } else {
            data.nodeid = `${data.type}_${data.id}x`;
            if (!isEmpty(data.users)) {
              id = [];
              data.users.forEach(u => {
                id.push(u.id);
              });
              id = id.join(",");
            }
          }
          if (id && searchKeysB.indexOf(id) < 0) {
            searchKeysB.push(id);
            rightDatasB.push(data);
            selectedDataB[id] = data;
          }
        }
      }

      if (maxLength && maxLength < this.countCrm(rightDatasB, true)) {
        window.alert(
          getLabel(385619, "所选人数不能超出$s人!").replace(/\$s/, maxLength)
        );
        this.throwCurrentState(
          this.formatKeys(this.state.searchKeys).join(","),
          this.formatDatas(this.state.rightDatas)
        );
        return;
      }
    }
    searchKeysB = uniq(searchKeysB);
    const formatedKeys = this.formatKeys(searchKeysB, selectedDataB);
    const formatedDatas = this.formatDatas(rightDatasB);
    this.setState({
      searchKeys: formatedKeys,
      selectedData: selectedDataB,
      rightDatas: formatedDatas
    });
    if (doChange) {
      this.throwCurrentState(formatedKeys.join(","), formatedDatas);
    }
    let ids = uniq(searchKeysB).join(",");
    this.setState({ hiddenIds: ids });
  }
  // 获取到部门下的人员信息
  getCrms(params) {
    const { dataParams = {} } = this.props;
    const { isAccount, checkStrictly } = this.state;
    let p = {};
    if (isAccount) p["isNoAccount"] = 1;
    if (!checkStrictly) p["alllevel"] = 1;
    return WeaTools.callApi(`/api/public/browser/data/1?cmd=resource`, "POST", {
      ...this.defaultConditionParams,
      ...p,
      ...dataParams,
      types: params
    });
  }
  // 部分，分部的人员信息
  formatCheckedData(datas, callResource = false) {
    return new Promise((resolve, reject) => {
      let apiParams = [];
      this.resourcesCache = {};
      datas.forEach(item => {
        if (item.type !== "resource") {
          apiParams.push(item.type + "|" + item.id);
        }
        if (callResource && item.type === "resource") {
          apiParams.push(item.id);
        }
      });
      if (apiParams.length > 0) {
        this.getCrms(apiParams.join(",")).then(
          resp => {
            if (resp.status) {
              resp.datas.forEach(r => {
                this.resourcesCache[r.type + r.id] = r;
              });
            }
            resolve(this.format(datas));
          },
          () => {
            window.console && console.log("formatCheckedData failed");
          }
        );
      } else {
        resolve(this.format(datas));
      }
    });
  }
  format(datas) {
    let result = [];
    const { isShowGroup } = this.props;
    datas.forEach(item => {
      let cache = this.resourcesCache[item.type + item.id] || item;
      if (item.type === "resource") {
        result.push(cache);
      } else {
        item.users = cache.users;
        if (isShowGroup) {
          if (item.isPrivate == "true") {
            result = result.concat(this.filterDatas(cache.users));
          } else {
            result.push(item);
          }
        } else {
          result = result.concat(this.filterDatas(cache.users));
        }
      }
    });
    return result;
  }
  onRightDoubleClick(key) {
    const { rightDatas } = this.state;
    const newRightDatas = rightDatas.filter(item => item.nodeid !== key);
    this.setState({ rightDatas: newRightDatas, rightCheckedKeys: [] });
  }
  onleftDoubleClick(datas) {
    const { rightDatas } = this.state;
    this.formatCheckedData(datas).then(datas => {
      this.setState({
        rightDatas: rightDatas.concat(datas),
        rightCheckedKeys: [],
        leftListSelectedData: [],
        leftTreeCheckedData: [],
        leftGroupCheckedData: [],
        leftGroupCheckedKeys: [],
        leftTreeCheckedKeys: [],
        leftListSelectedKeys: []
      });
    });
  }
  moveTo = direction => {
    const { rightDatas, rightCheckedKeys, listDatas } = this.state;

    if (direction === "right") {
      const {
        leftListSelectedData,
        leftTreeCheckedData,
        leftGroupCheckedData
      } = this.state;
      const datas = leftListSelectedData
        .concat(leftTreeCheckedData)
        .concat(leftGroupCheckedData);
      this.setState({ loading: true }, () => {
        this.formatCheckedData(datas).then(datas => {
          this.setState({
            loading: false,
            rightDatas: uniqBy(rightDatas.concat(datas), "nodeid"), // 解决可以选重复数据问题
            rightCheckedKeys: [],
            leftListSelectedData: [],
            leftTreeCheckedData: [],
            leftGroupCheckedData: [],
            leftGroupCheckedKeys: [],
            leftTreeCheckedKeys: [],
            leftListSelectedKeys: []
          });
        });
      });
    }
    if (direction === "left") {
      const newRightDatas = rightDatas.filter(
        item => !rightCheckedKeys.some(checkedKey => item.nodeid === checkedKey)
      );

      this.setState({ rightDatas: newRightDatas, rightCheckedKeys: [] });
    }

    if (direction === "allToLeft") {
      this.setState({ rightDatas: [], rightCheckedKeys: [] });
    }

    if (direction === "allToRight") {
      if (this.leftListAllActive()) {
        this.setState({
          rightDatas: rightDatas.concat(this.filterDatas(listDatas)),
          rightCheckedKeys: [],
          leftListSelectedData: [],
          leftTreeCheckedData: [],
          leftGroupCheckedData: [],
          leftGroupCheckedKeys: [],
          leftTreeCheckedKeys: [],
          leftListSelectedKeys: []
        });
      }
    }
  };
  filterDatas(datas) {
    const { rightDatas } = this.state;
    let res = [];
    let ids = [];
    if (rightDatas) {
      rightDatas.forEach(d => {
        if (d.type == "resource") {
          ids.push(d.id);
        } else {
          d.users &&
            d.users.forEach(u => {
              ids.push(u.id);
            });
        }
      });
    }
    if (datas) {
      res = datas.filter(
        item => ids.indexOf(item.id) == -1 || item.type != "resource"
      );
    }
    return res;
  }
  moveToLeft = () => this.moveTo("left");
  moveToRight = () => this.moveTo("right");
  moveAllToLeft = () => this.moveTo("allToLeft");
  moveAllToRight = () => this.moveTo("allToRight");
  formatInput = columns => {
    let inputTop, inputBottom;
    if (!isEmpty(columns)) {
      inputTop = [];
      inputBottom = [];
      columns.forEach(item => {
        if (item.hide === "false") {
          if (item.showType === "1") {
            inputTop.push(item.dbField || item.dataIndex);
          }
          if (item.showType === "0") {
            inputBottom.push(item.dbField || item.dataIndex);
          }
        }
      });
    }
    this.setState({
      inputTop: inputTop,
      inputBottom: inputBottom
    });
  };
  countCrm(rightDatas, rNum = false) {
    let count = 0;
    let ids = [];
    rightDatas.forEach(item => {
      if (item.type === "all") {
        count += item.count;
      } else if (item.type !== "resource") {
        count += (item.users || []).length;
      } else {
        ids.push(item.id);
      }
    });
    count += uniq(ids).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }
  leftListAllActive() {
    const { rightDatas, listDatas } = this.state;
    let bool = true;
    if (isEmpty(listDatas)) bool = false;
    if (!isEmpty(listDatas) && !isEmpty(rightDatas)) {
      let ids = [];
      rightDatas.forEach(d => {
        if (d.type == "resource") {
          ids.push(d.id);
        } else {
          d.users &&
            d.users.forEach(u => {
              ids.push(u.id);
            });
        }
      });
      bool = listDatas.filter(l => !ids.some(r => l.id === r)).length !== 0;
    }
    return bool;
  }
  strToArray(str) {
    let r = [];
    if (str) r.push(str);
    return r;
  }
  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    const { memorise } = this.props;
    if (memorise) {
      const { searchKeys, selectedData } = this.state;
      this.onBrowerClick(searchKeys, selectedData);
    } else {
      this.onBrowerClick();
    }
  };
  focus() {
    this.refs.associativeSearch.focus();
  }

  // 增加自定义输入框内人员展示顺序方法
  formatKeys = (values, datas) => {
    let formaredKeys = values;
    const { formatKeys } = this.props;
    if (formatKeys && typeof formatKeys === "function") {
      formaredKeys = formatKeys(values, datas);
    }
    return formaredKeys;
  };

  // 增加自定义弹框右侧内人员展示顺序方法
  formatDatas = datas => {
    let formatedDatas = datas;
    const { formatDatas } = this.props;
    if (formatDatas && typeof formatDatas === "function") {
      formatedDatas = formatDatas(values, datas);
    }
    return formatedDatas;
  };

  render() {
    const {
      is_012app,
      noScroll = false,
      customized,
      fieldName,
      contentHeight = 410,
      dropMenuIcon,
      recentUrl,
      topPrefix,
      grouptree,
      resourcetree,
      type,
      checkGroup
    } = this.props;
    const {
      companyId,
      loading,
      activeKey,
      showSearchAd,
      virtualDatas,
      grouptreeData,
      rsctreeData,
      listDatas,
      inputValue,
      pageSize,
      count,
      currentPage,
      hasPagination,
      hiddenIds,
      searched,
      rightDatas,
      rightCheckedKeys,
      leftTreeCheckedKeys,
      leftListSelectedKeys,
      selectedData,
      searchKeys,
      leftGroupCheckedKeys,
      checkStrictly,
      isAccount,
      showAllbranch,
      inputTop,
      inputBottom
    } = this.state;
    const { state, props } = this;
    let menuItem = [];
    virtualDatas.map(item => {
      menuItem.push(<Menu.Item key={item.id}>{item.virtualtype}</Menu.Item>);
      menuItem.push(<Menu.Divider />);
    });
    const typeMenu = (
      <Menu
        className="wea-hr-muti-input-drop-menu wea-browser-drop-menu max-height"
        onSelect={this.onSelect.bind(this)}
        selectedKeys={this.strToArray(companyId)}
      >
        {menuItem}
      </Menu>
    );
    let inputArr = (
      <WeaAssociativeSearchMult
        {...this.props}
        ref="associativeSearch"
        style={this.props.inputStyle}
        datas={selectedData}
        selectedValues={searchKeys}
        type={type}
        hasScroll={!noScroll}
        clickCallback={this.onBrowerClick}
        appendSearchValues={this.appendSearchValues.bind(this)}
        onChange={this.onBrowerChange.bind(this)}
        dropAllUserGroup={this.props.dropAllUserGroup}
      />
    );
    const buttons = [
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk.bind(this)}
        disabled={this.countCrm(rightDatas, true) == 0}
      >
        {getLabel(385565, "确 定")}
        {this.countCrm(rightDatas)}
      </Button>,
      <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
        {getLabel(385566, "清 除")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    const searchsBox = this.getSearchs();
    const buttonsAd = this.getTabButtonsAd();
    const rightActive =
      leftTreeCheckedKeys.length +
        leftListSelectedKeys.length +
        leftGroupCheckedKeys.length >
      0;
    // const leftAllActive =
    //   (activeKey === "1" ||
    //     activeKey === "2" ||
    //     activeKey === "3" ||
    //     searched) &&
    //   this.leftListAllActive();
    // const showList = activeKey === "1" || activeKey === "2" || activeKey === "3" || searched;
    const showList = (activeKey !== "4" && activeKey !== "5") || searched;
    const leftAllActive = showList && this.leftListAllActive();
    let initHeight = contentHeight;
    if (window.setLayoutWindow) {
      let maxH = $(window.setLayoutWindow.document.body).height() - 220;
      if (window.setDialogFullWindow || initHeight > maxH) {
        initHeight = maxH;
      }
    }
    let sheight = initHeight;
    if (hasPagination) sheight -= 35; //显示分页
    // if (activeKey != "1" && activeKey != "5" && !searched) sheight -= 37; //显示维度
    if (
      (activeKey === "2" || activeKey === "3" || activeKey === "4") &&
      !searched
    )
      sheight -= 37; //显示维度
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    let contents = (
      <div>
        {showList && (
          <WeaHrmList
            {...this.props}
            is_012app={is_012app}
            onDoubleClick={this.onleftDoubleClick.bind(this)}
            onClick={this.onLeftListCheck.bind(this)}
            selectedKeys={leftListSelectedKeys}
            filterData={rightDatas}
            datas={listDatas}
            inputTop={inputTop}
            inputBottom={inputBottom}
          />
        )}
        {!showList && activeKey === "4" && rsctreeData && (
          <WeaTreeHrMult
            {...this.props}
            icon={props.icon}
            iconBgcolor={props.iconBgcolor}
            dataUrl={resourcetree}
            checkStrictly={checkStrictly}
            isAccount={isAccount}
            virtualtype={this.state.companyId}
            className="rsc-wrapper"
            recentUrl={recentUrl}
            checkGroup={checkGroup} // 可以选择部门，分部
            treeKey="hr"
            topPrefix={topPrefix}
            isMult={true}
            checkedKeys={leftTreeCheckedKeys}
            onDoubleClick={this.onleftDoubleClick.bind(this)}
            checkedCb={this.onLeftTreeCheck.bind(this)}
            treeData={rsctreeData}
            filterData={this.getFilterData(rightDatas)}
            defaultExpandedKeys={this.defaultExpandedKeys(rsctreeData.datas)}
          />
        )}
        {!showList && activeKey === "5" && grouptreeData && (
          <WeaTreeHrMult
            {...this.props}
            icon={props.icon}
            iconBgcolor={props.iconBgcolor}
            dataUrl={grouptree}
            checkStrictly={checkStrictly}
            isAccount={isAccount}
            recentUrl={recentUrl}
            checkGroup={checkGroup}
            treeKey="hr"
            topPrefix={topPrefix}
            isMult={true}
            checkedKeys={leftGroupCheckedKeys}
            onDoubleClick={this.onleftDoubleClick.bind(this)}
            checkedCb={this.onLeftGroupCheck.bind(this)}
            treeData={grouptreeData}
            getGrouptree={this.getGrouptree}
            filterData={rightDatas}
            defaultExpandedKeys={this.defaultExpandedKeys(grouptreeData.datas)}
          />
        )}
      </div>
    );
    return (
      <div>
        {dom}
        <input
          type="hidden"
          id={fieldName}
          name={fieldName}
          value={hiddenIds}
        />
        <WeaDialog
          onCancel={this.handleCancel.bind(this)}
          className={"wea-hr-muti-input wea-browser-modal"}
          visible={state.visible}
          title={props.title}
          icon={props.icon}
          iconBgcolor={props.iconBgcolor}
          maskClosable={false}
          style={{ width: 784 }}
          zIndex={props.zIndex}
          buttons={buttons}
        >
          {this.renderTab()}
          <Spin spinning={loading}>
            <div style={{ padding: 10 }}>
              <div className="wea-hr-muti-input-left">
                <Row style={{ height: "35px" }}>
                  <Col span="18">
                    <WeaInputSearch
                      placeholder={
                        this.props.is_012app
                          ? getLabel(385569, "请输入人员姓名或工号")
                          : getLabel(385570, "请输入人员姓名")
                      }
                      value={inputValue}
                      onSearchChange={v => {
                        this.setState({ inputValue: v }, () => {
                          this.debounced(v);
                        });
                      }}
                      onSearch={this.onSearchChange.bind(this)}
                    />
                  </Col>
                  <Col span="6">
                    <Button
                      className="wea-workflow-serch-condition"
                      title={getLabel(347, "高级搜索")}
                      type="ghost"
                      onClick={this.setShowSearchAd.bind(this, true)}
                    >
                      {getLabel(347, "高级搜索")}
                    </Button>
                  </Col>
                </Row>
                <div
                  className="wea-search-wrap"
                  style={{ display: showSearchAd ? "block" : "none" }}
                >
                  <Button
                    type="ghost"
                    className="wea-advanced-search"
                    title={getLabel(347, "高级搜索")}
                    onClick={this.setShowSearchAd.bind(this, false)}
                  >
                    {getLabel(347, "高级搜索")}
                  </Button>
                  <div className="wea-advanced-searchs">
                    <Form horizontal>
                      {this.state.initialShowSearchAd && searchsBox}
                      <div className="wea-search-buttons">
                        <div style={{ textAlign: "center" }}>
                          {this.state.initialShowSearchAd &&
                            buttonsAd &&
                            buttonsAd.map(data => {
                              return (
                                <span style={{ marginLeft: 15 }}>{data}</span>
                              );
                            })}
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
                {(activeKey === "2" ||
                  activeKey === "3" ||
                  activeKey === "4") &&
                  !searched && (
                    <Row>
                      <Col span={24}>
                        <Dropdown overlay={typeMenu} trigger={["click"]}>
                          <a className="wea-dropdown-link" href="javascript:;">
                            <span className="wea-dropdown-link-menuicon">
                              {dropMenuIcon}
                            </span>
                            <div
                              className="text-elli wea-dropdown-link-company"
                              title={this.state.companysDefault}
                            >
                              {this.state.companysDefault}
                            </div>
                            <Icon
                              type="down"
                              className="wea-dropdown-link-downicon"
                            />
                          </a>
                        </Dropdown>
                      </Col>
                    </Row>
                  )}
                {(activeKey === "2" ||
                  activeKey === "3" ||
                  activeKey === "4" ||
                  activeKey === "5") && (
                  <div
                    className="operation-wrap"
                    style={{ top: searched || activeKey === "5" ? 42 : 78 }}
                  >
                    {activeKey === "3" && (
                      <Button
                        size="small"
                        onClick={this.onBranchBtnClick.bind(this)}
                        title={
                          showAllbranch
                            ? getLabel(390066, "隐藏下级下属")
                            : getLabel(83783, "显示下级下属")
                        }
                      >
                        <span>
                          {showAllbranch ? (
                            <i
                              className="icon-coms-DisplaySubordinates"
                              style={{ color: "#2db7f5" }}
                            />
                          ) : (
                            <i className="icon-coms-NoDisplayOfSubordinates" />
                          )}
                        </span>
                      </Button>
                    )}
                    {(activeKey === "4" || activeKey === "5") && (
                      <Button
                        size="small"
                        onClick={() =>
                          this.setState({ checkStrictly: !checkStrictly })
                        }
                        title={
                          checkStrictly
                            ? getLabel(390067, "不包含下级机构")
                            : getLabel(33454, "包含下级机构")
                        }
                      >
                        <span>
                          {!checkStrictly ? (
                            <i
                              className="icon-coms-DisplaySubordinates"
                              style={{ color: "#2db7f5" }}
                            />
                          ) : (
                            <i className="icon-coms-NoDisplayOfSubordinates" />
                          )}
                        </span>
                      </Button>
                    )}
                    <Button
                      size="small"
                      onClick={this.onAccountBtnClick.bind(this)}
                      title={
                        isAccount
                          ? getLabel(385568, "隐藏无账号人员")
                          : getLabel(31504, "显示无账号人员")
                      }
                    >
                      <span>
                        {isAccount ? (
                          <i
                            className="icon-coms-ShowNoAccount"
                            style={{ color: "#2db7f5" }}
                          />
                        ) : (
                          <i className="icon-coms-NoAccountNoDisplay" />
                        )}
                      </span>
                    </Button>
                  </div>
                )}
                {noScroll ? (
                  <div style={{ height: sheight, overflowY: "scroll" }}>
                    {contents}
                  </div>
                ) : (
                  <WeaNewScroll height={sheight} ref="weaSrcoll">
                    {contents}
                  </WeaNewScroll>
                )}
                {hasPagination && (
                  <Pagination
                    weaSimple
                    showTotal={total =>
                      getLabel(385617, "共$s条").replace(/\$s/, total)
                    }
                    total={count}
                    pageSize={pageSize}
                    current={currentPage}
                    onChange={this.onPageChange.bind(this)}
                  />
                )}
              </div>
              <div className="wea-transfer-opration">
                <Operation
                  {...this.props}
                  rightActive={rightActive}
                  leftActive={rightCheckedKeys.length > 0}
                  leftAllActive={leftAllActive}
                  rightAllActive={rightDatas.length > 0}
                  moveToRight={this.moveToRight}
                  moveToLeft={this.moveToLeft}
                  moveAllToRight={this.moveAllToRight}
                  moveAllToLeft={this.moveAllToLeft}
                />
              </div>
              <div className="wea-hr-muti-input-right">
                <WeaTransferRight
                  {...this.props}
                  ref="browserRight"
                  noScroll={noScroll}
                  data={rightDatas}
                  checkedCb={this.onRightCheck.bind(this)}
                  onDoubleClick={this.onRightDoubleClick.bind(this)}
                  checkedKeys={rightCheckedKeys}
                  height={initHeight}
                  inputTop={inputTop}
                  inputBottom={inputBottom}
                  onDrag={data => {
                    this.setState({ rightDatas: data });
                  }}
                />
              </div>
            </div>
          </Spin>
        </WeaDialog>
      </div>
    );
  }
  onLeftListCheck(keys, datas) {
    const { leftListSelectedData } = this.state;
    let targets = leftListSelectedData.concat(datas);
    targets = uniqBy(targets, "id");
    targets = targets.filter(t => keys.indexOf(t.id) > -1);
    this.setState({
      leftListSelectedKeys: keys,
      leftListSelectedData: targets
    });
  }
  onLeftTreeCheck(checkedKeys, datas) {
    this.setState({
      leftTreeCheckedKeys: checkedKeys,
      leftTreeCheckedData: datas
    });
  }
  onLeftGroupCheck(checkedKeys, datas) {
    this.setState({
      leftGroupCheckedKeys: checkedKeys,
      leftGroupCheckedData: datas
    });
  }
  onRightCheck(keys) {
    this.setState({ rightCheckedKeys: keys });
  }
  throwCurrentState(ids, datas = []) {
    this.setState({ hiddenIds: ids });
    let names = [];
    datas.forEach(d => {
      d.name = d.name || d.lastname;
      names.push(d.name);
    });
    this.props.onChange && this.props.onChange(ids, names.join(","), datas);
  }

  getSearchs() {
    const { browserConditions } = this.state;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
              viewAttr={field.viewAttr}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 1,
          hide: WeaTools.isComponentHide(field)
        });
      });
    return <WeaSearchBrowserBox items={items} />;
  }

  getTabButtonsAd() {
    let _this = this;
    const { resetFields, validateFields } = this.props.form;
    return [
      <Button
        type="primary"
        onClick={e => {
          this.goSearch(e);
        }}
      >
        {getLabel(197, "搜索")}
      </Button>,
      <Button
        type="ghost"
        onClick={e => {
          e.preventDefault();
          this.reset();
        }}
      >
        {getLabel(2022, "重置")}
      </Button>,
      <Button
        type="ghost"
        onClick={() => {
          _this.setState({ showSearchAd: false });
        }}
      >
        {getLabel(31129, "取消")}
      </Button>
    ];
  }
  getFilterData = datas => {
    let filterDatas = [];
    if (!isEmpty(datas) && datas.length) {
      datas.map(data => {
        if (data === "resource") {
          filterDatas.push(data);
        } else if (data.users) {
          filterDatas = filterDatas.concat(data.users);
        }
      });
    }
    return filterDatas;
  };
  reset() {
    const { resetFields, setFieldsValue } = this.props.form;
    const { browserConditions } = this.state;
    const fields = {};
    browserConditions.forEach(c => {
      let ct = c.conditionType.toUpperCase();
      let domkey = c.domkey[0];
      const filterKeys = [1, -1, "1", "-1"];
      if (ct === "BROWSER") {
        if (
          !isEmpty(c.browserConditionParam) &&
          filterKeys.indexOf(c.browserConditionParam.viewAttr) == -1
        ) {
          fields[domkey] = undefined;
        }
      } else if (ct === "SELECT") {
        let v = WeaTools.getSelectDefaultValue(c.options) || "";
        fields[domkey] = v;
      } else if (ct === "DATE") {
        let v = WeaTools.getValueByfield(c);
        if (v && v.value) {
          c.domkey.forEach((d, idx) => {
            fields[d] = v.value[idx];
          });
        }
      } else if (ct === "SCOPE") {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          fields[c.domkey[1]] = undefined;
        }
      } else {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
        }
      }
    });
    setFieldsValue(fields);
    this.setState({ inputValue: "" });
  }
  defaultExpandedKeys(data) {
    let arr = [];
    const { topPrefix } = this.props;
    const loop = data =>
      data.forEach(item => {
        if (item.children && !!item.open) {
          arr.push(`${topPrefix}0-${item.nodeid}`);
          loop(item.children);
        } else {
          !!item.open && arr.push(item.nodeid);
        }
      });
    !!data.open && arr.push(`${topPrefix}0-${data.nodeid}`);
    if (data.children) {
      loop(data.children);
    }
    return arr;
  }
}
const formatSelectOptions = options => {
  let results = [];
  forEach(options, option => {
    results.push({
      value: option.id,
      name: option.name ? option.name : option.virtualtype
    });
  });
  return results;
};

export default Form.create()(main);



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-hrm-mult/index.js